import { network } from 'services/network';

export const getComponentsConfiguration = () => {
    const url = `api/bo/reporting/getComponentsConfiguration`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
